import { Link } from 'react-router-dom';
import { Videocam } from '@mui/icons-material';
import { RouteEnum, generateRoutePath } from 'App';
import { ToAuditButtonProps } from './ToAuditButton.types';
import * as S from './ToAuditButton.styled';

export const ToAuditButton = (props: ToAuditButtonProps) => {
  const { uuid, secondUuid, title, onClick, route = RouteEnum.AuditQueue } = props;
  const to = generateRoutePath({
    name: route,
    params: { audit: secondUuid || uuid, session: secondUuid && uuid },
  });

  if (onClick) {
    return (
      <S.AuditButton
        variant='outlined'
        size='small'
        onClick={() => onClick(uuid)}
        startIcon={<Videocam />}
      >
        {title}
      </S.AuditButton>
    );
  }

  return (
    <Link to={to}>
      <S.AuditButton variant='outlined' size='small' startIcon={<Videocam />}>
        {title}
      </S.AuditButton>
    </Link>
  );
};
